export default "__VITE_ASSET__DRKXDVT6__"